module.exports = __webpack_public_path__ + "img/96.4118ced0.gif";